<style scoped>
    .togs_of{
        margin: 0px;
        text-align: center;
        text-transform: capitalize;
    }
    .community_chanel{
        text-transform: capitalize;
        text-align: center;
        margin: 0px;
    }
    .humtog_s{
        margin-bottom: 20px;
        background-color: #f5f8fa;
    }
    .comtt_c{
        border-left: none !important;
    }
    .community_togs{
        padding-left: 15px !important;
        list-style-type: none;
    }
    .h_b{
        background-color: #5587d7;
        color: #fff;
        border-radius: 20px;
        padding: 7px 17px 10px 17px;
    }
    .f_f{
        text-align: justify;
    }
    .f_f_m{
        text-align: center;
        margin-left: 62px !important;
    }
    .f_f a{
        argin: 62px;
    }
</style>
<template>
    <div class="sidebar-right user-select comtt_c">
        <el-card class="box-card humtog_s">
            <!-- <h2 class="community_chanel">Credentials</h2> -->
            <!-- <p>Lives in {{userStore.info.location}}</p> -->
            <p>Joined - {{ date }}</p>
            <!--<div style="text-align: center"> <router-link class="item h_b" to="/">Learn More</router-link> </div>-->
        </el-card>
        <!-- <el-card class="box-card humtog_s">
            <div>
                <h2 class="community_chanel">Active In</h2>
                <div class="f_f_m">
                    <div class="f_f">
                        <router-link :to="{ path: '/' }" class="nav-itemis-tab">
                            News Only >
                        </router-link>
                    </div>
                    <div class="f_f">
                        <router-link :to="{ path: '/' }" class="nav-itemis-tab">
                            Articals Only >
                        </router-link>
                    </div>
                    <div class="f_f">
                        <router-link :to="{ path: '/' }" class="nav-itemis-tab">
                            Q&A Only >
                        </router-link>
                    </div>
                    <div class="f_f">
                        <router-link :to="{ path: '/' }" class="nav-itemis-tab">
                            Photos Only >
                        </router-link>
                    </div>
                </div>
            </div>
        </el-card> -->
    </div>
</template>

<script>

    import Helpers from '../../mixins/Helpers';
    export default {
        mixins: [Helpers],
        data() {
            return {

            };
        },

        watch: {

        },

        computed: {
            userStore() {
                return Store.page.user.temp;
            },
            date() {
                return moment(this.userStore.created_at)
                    .utc(moment().format('D MMM YYYY'))
                    .format('D MMM YYYY');
            },

        },

        created() {

        },

        methods: {

        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sidebars/UsersSidebar.vue